import { type Locale } from '@framework/i18n/config.ts';
import { useCurrentLocale } from '@framework/i18n/hooks/useCurrentLocale.ts';
import { i18next } from '@framework/i18n/intl/init.ts';
import { getLocalesAsArray } from '@framework/i18n/utils.ts';
import { Divider, Space } from 'antd';
import clx from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LanguageButton } from '../../ui/menu/LanguageButton.tsx';
import { MobileLanguageMenu } from './MobileLanguageMenu.tsx';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  .ant-space-item-split {
    z-index: 0;
  }
  .ant-space-item {
    z-index: 1;
  }
  /* padding-inline: 1rem; */
`;
const StyledDivider = styled(Divider)`
  margin: 0;
  min-height: 28px;
`;

const locales = getLocalesAsArray();
export interface ILanguageMenuProps {
  isMobile?: boolean | null;
}

export function LanguageMenu(props: ILanguageMenuProps) {
  const { isMobile } = props;
  const currentLanguage = useCurrentLocale();
  const { t } = useTranslation();

  const handleClick = useCallback((locale: Locale) => {
    i18next.changeLanguage(locale.tag);
    window.location.reload();
  }, []);

  if (isMobile) {
    return (
      <MobileLanguageMenu
        selected={currentLanguage}
        locales={locales}
        onSelected={handleClick}
      />
    );
  }
  return (
    <StyledWrapper>
      <Space
        size="large"
        role="navigation"
        aria-label={t(
          'layout.header.menu-di.scelta-lingua',
          'Menu di scelta lingua',
        )}
      >
        <Space
          size={0}
          align="center"
          split={!isMobile && <StyledDivider type="vertical" />}
        >
          {locales.map(locale => (
            <LanguageButton
              className={clx({
                selected: currentLanguage.tag === locale.tag,
              })}
              key={locale.tag}
              disabled={currentLanguage.tag === locale.tag}
              onClick={() => handleClick(locale)}
            >
              {locale.label}
            </LanguageButton>
          ))}
        </Space>
      </Space>
    </StyledWrapper>
  );
}
